module.exports = __webpack_public_path__ + "static/media/bullet-list-69_1.419f546d.svg";